import { create } from 'zustand';
import { SessionState, SessionActions } from './types';
import { initialState } from './initial-state';

export const useSessionStore = create<SessionState & SessionActions>((set) => ({
  ...initialState,
  saveUser: (user) => set({ user }),
}));
